<template lang="pug">
  div
    slot(:component="getComponentNameByType(taskUnit.type)" :value="value")
</template>

<script>
import { TASK_UNIT_TYPE_NAMES } from '@/modules/Tasks/TaskUnits/constants';

import TypeMark from '@/modules/Tasks/TaskUnits/components/answers/TypeMark.vue';
import TypeText from '@/modules/Tasks/TaskUnits/components/answers/TypeText.vue';
import TypeLink from '@/modules/Tasks/TaskUnits/components/answers/TypeLink.vue';
import TypeFile from '@/modules/Tasks/TaskUnits/components/answers/TypeFile.vue';
import TypeChoices from '@/modules/Tasks/TaskUnits/components/answers/TypeChoices.vue';

export default {
  props: {
    taskUnit: { type: Object, required: true },
    answer: { type: Object, default: null },
  },
  computed: {
    value() {
      if (!this.answer) return null;
      return {
        ...this.answer,
        possible_answers: this.answer.possible_answers.map((i) => ({
          id: i.id,
          name: i.name,
          user_selected: i.user_selected,
          correct_answer: i.correct_answer,
          total_user_choice: i.count_answer || i.possible_answers_count_by_all_user,
          total_current_user_choice: i.possible_answers_count_by_current_user,
        })),
      };
    },
  },
  methods: {
    getComponentNameByType(type) {
      switch (type) {
        case TASK_UNIT_TYPE_NAMES.readingMark: {
          return TypeMark;
        }
        case TASK_UNIT_TYPE_NAMES.textAnswer: {
          return TypeText;
        }
        case TASK_UNIT_TYPE_NAMES.link: {
          return TypeLink;
        }
        case TASK_UNIT_TYPE_NAMES.choiceOneOption: {
          return TypeChoices;
        }
        case TASK_UNIT_TYPE_NAMES.choiceSeveralOptions: {
          return TypeChoices;
        }
        case TASK_UNIT_TYPE_NAMES.file: {
          return TypeFile;
        }
        default: {
          return false;
        }
      }
    },
  },
};
</script>
